
import { Base } from '../base-component';

import './article-page-news-intro.component.scss';

export class ArticlePageNewsIntro extends Base {

	constructor(element: Element){

		super(element)
				
	}

	init(){}
		
	bindEvents(){}

}




// WEBPACK FOOTER //
// ./components/article-page-news-intro/article-page-news-intro.component.ts